import { ValueOf } from 'type-fest';

/**
 * @see https://docs.tosspayments.com/reference/codes#%EC%9D%80%ED%96%89-%EC%BD%94%EB%93%9C
 */
export const Bank = {
  경남: `KYONGNAMBANK`,
  광주: `GWANGJUBANK`,
  국민: `KOOKMIN`,
  기업: `IBK`,
  농협: `NONGHYEOP`,
  대구: `DAEGUBANK`,
  부산: `BUSANBANK`,
  산업: `KDB`,
  새마을: `SAEMAUL`,
  산림: `SANLIM`,
  수협: `SUHYEOP`,
  신한: `SHINHAN`,
  신협: `SHINHYUP`,
  씨티: `CITI`,
  우리: `WOORI`,
  우체국: `POST`,
  저축: `SAVINGBANK`,
  전북: `JEONBUKBANK`,
  제주: `JEJUBANK`,
  카카오: `KAKAOBANK`,
  케이: `KBANK`,
  토스: `TOSSBANK`,
  하나: `HANA`,
  SC제일: `SC`,
} as const;

export type Bank = keyof typeof Bank;

export type BankCode = ValueOf<typeof Bank>;
